attachEvent('[data-mode-switch]', 'click', (ev) => {
  const inputs = document.querySelectorAll('[data-mode-input]');
  inputs.forEach((el) => {
    el.checked = !el.checked;
  });
  document.body.classList.toggle('is-dark-mode');
  ev.preventDefault();
});
